<template>
  <div>
  <!-- navigation -->
 <Navigation> </Navigation>
  <!-- navigation -->

    <section class="home-container" id="home">
        <div class="container">
            <div class="row">
                <div class="col-lg-7 col-md-7">
                    <h3 class="display-4 home-main-text">
                        Helpdesk
                    </h3>
                    <h2>Get help from desk</h2>

                    <br>
                    <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                        been the industry's standard dummy text ever since the 1500s.</span>
                </div>

                <div class="col-lg-5 col-md-5">

                    
                <div v-if="canLogin==true">
                    <img :src="'imgs/img_helpdesk.png'" class="img-fluid mt-5" alt="">
                </div>
                   

                   <div v-else-if="canRegister==false">
                    <h6  class="mt-5">Get started with your 10-days free trial</h6>
                    <div>
                        <input type="text" class="trial-form" placeholder="Email" />
                        <br>
                        <input type="text" class="mt-2 trial-form" placeholder="Password" />
                        <p>Powered by Aruvaa. Kindly read the terms of services before you proceed.</p>
                        <input type="checkbox" class="checkbox-form"> I agree to the <span class="terms-privacy-text"><a
                                href="">Terms of Services</a></span>
                        and <span class="terms-privacy-text"><a href="">Privacy Policy</a></span>
                        <br>
                        <br>
                        <a href="">
                            <button class="free-trial-btn">Start Free Trial</button>
                        </a>
                    </div>
                 </div>
                   
                </div>
            </div>
        </div>
    </section>
  <!-- helpdesk get the help end-->
  
    <div style="background-color: blue; margin-top:-5px;">

        <div class="pt-4 pb-4">
            <div class="container">
                <h2 class="text-white text-center">Most Easiest Helpdesk solution for your business</h2>
            </div>
            <div class="row">
                <img :src="'/imgs/ic_pencil_left.png'" class="img-fluid col-lg-2" alt="" width="5%">
                <img :src="'/imgs/ic_helpdesk_catalog.png'" class="img-fluid col-lg-8" alt="">
                <img :src="'/imgs/ic_pencil_right.png'" class="img-fluid col-lg-2" alt="">
            </div>

        </div>
    </div>

<!-- why you nees helpdesk -->
<section style="background-color: #333333" class="pt-4 pb-4">

        <!--Text-->
        <div class="container">
            <h2 class="text-white text-center">Why you need Helpdesk?</h2>
        </div>
        <!--Container-->

        <div class="container mt-5">

            <!--First Row-->

            <div class="row lines">
                <div class="col text-center hvr-pulse">
                    <a href="#" class="nav-link">
                        <i class="fas fa-desktop why-icons"></i>
                        <br>
                        <p class="adv-text text-white">Quality</p>
                    </a>
                </div>
                <div class="col text-center hvr-pulse">
                    <a href="#" class="nav-link">
                        <i class="fas fa-desktop why-icons"></i>
                        <p class="adv-text text-white">Industry Best Prices
                            & Offers</p>
                    </a>
                </div>
                <div class="col text-center hvr-pulse">
                    <a href="#" class="nav-link">
                        <i class="fas fa-desktop why-icons"></i>
                        <p class="adv-text text-white">Multi-Channel
                            24/7 Support</p>
                    </a>
                </div>
                <div class="col  text-center hvr-pulse ">
                    <a href="#" class="nav-link">
                        <i class="fas fa-desktop why-icons"></i>
                        <p class="adv-text text-white">Easy Setup &
                            Integration</p>
                    </a>
                </div>
            </div>

            <!--/First Row End-->

        </div>
        <!--/Second Row End-->
</section>
        <!-- Mobile Starts here -->
    <section class="what_we_do_mobile_container">
        <div class="container text-center">
            <div class="text-center">
                <h2 class="text-center">What we do?</h2>
            </div>
            <br>
            <br>

            <h4 class="">Websites that take your business to next level</h4>
            <img :src="'/imgs/ic_team.png'" class="img-fluid" width="250">

            <h4 class="">A Digital Marketing approach that gives
                higher conversions
                and more leads</h4>

            <img :src="'/imgs/ic_cup.png'" alt="novaelixr" class="img-fluid" width="250" />

            <h4 class="">Innovative Branding to
                make your brand the
                next household name</h4>

            <img :src="'/imgs/ic_speaker.png'" class="img-fluid" width="250">
        </div>

    </section>

    <!-- what we do -->
    <!-- Desktop Starts here -->
    <section class="what_we_do_desktop_container">
        <section>
            <div class="container p-4">
                <div class="text-center">
                    <h2 class="text-center">What we do?</h2>
                </div>
                <br>
                <br>
                <div class="row mt-4">
                    <div class="col-lg-6 text-center">
                        <img :src="'/imgs/ic_team.png'" class="img-fluid vert-move-two" width="280">
                    </div>
                    <div class="col-lg-6">
                        <h4 class="">Websites that take your business to next
                            level</h4>
                        <p>This is a dummy text. This is a dummy text. This is a dummy text. This is a dummy text. This
                            is a dummy text. This is a dummy text. This is a dummy text. This is a dummy text. This is a
                            dummy text.</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- What We do - ENDS -->

        <!-- Digital Marketing - STARTS -->


         <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <h4 class="">A Digital Marketing approach that gives
                            higher conversions
                            and more leads</h4>
                        <p>This is a dummy text. This is a dummy text. This is a dummy text. This is a dummy text. This
                            is a dummy text. This is a dummy text. This is a dummy text. This is a dummy text. This is a
                            dummy text.</p>
                    </div>
                    <div class="col-lg-6 text-center">
                        <img :src="'/imgs/ic_cup.png'" class="img-fluid vert-move" width="250" />
                    </div>
                </div>
            </div>
        </section>
        <!-- Digital Marketing - ENDS -->

        <!-- Innovative Branding - STARTS -->
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 text-center">
                        <img :src="'/imgs/ic_speaker.png'" class="img-fluid vert-move-two" width="250">
                    </div>
                    <div class="col-lg-6">
                        <h4 class="">Innovative Branding to
                            make your brand the
                            next household name</h4>
                        <p>This is a dummy text. This is a dummy text. This is a dummy text. This is a dummy text. This
                            is a dummy text. This is a dummy text. This is a dummy text. This is a dummy text. This is a
                            dummy text.</p>
                    </div>

                </div>
            </div>
        </section>
        <!-- Innovative Branding - ENDS -->
    </section>

<!-- pricing table -->

        <!-- pricing table  -->
      <section id="plansPricing">

            <div class="container text-center">

                <h2 class="text-center features-heading pt-4 mt-5">Plans &amp; Pricing</h2>
                <p class="text-lg font-weight-bold">Choose a plan</p>

                <div class="container mt-5">
                    <div class="pricing card-deck flex-column flex-md-row" >
                        <div class="card card-pricing text-center px-3 mb-4" v-for="(data,key) in plansData">
                             <span class="h6 w-55 mx-auto px-4 py-1 rounded-bottom bg-primary text-white shadow-sm">{{data.name}}</span> 
                          

                            <div >
                                <label class="text-lg font-weight-bold">{{data.description}}</label>

                                <select class="form-control" :required="true" @change="onChange($event)">
                                     <option value="Choose Pricing" selected="selected">Choose Pricing</option>
                                     <option v-for="pricing in data.rlt_subscriptionplan_subscriptionprice" v-bind:value="pricing.id"  >{{ pricing.name }}</option>
                                </select>
                            </div>
                            
                            <br>
                            <p class="text-lg font-weight-bold">Features</p>
                            
                            <div class="card-body pt-0">
                              <ul class="list-unstyled" v-for="feature in data.features.split(',')" :feature="feature">
                                    <li class="feature">
                                      <span class="text-sm">{{ feature }}</span>
                                    </li>
                                </ul>
                             
                                <br>

                             <div v-if="canLogin === true" class="w-full" style="position:absolute; bottom:0; left:0; right:0">
                             <jet-button  @click="moveToNextPage(data.id,$event)" class="w-full"> <button type="button" class="w-full p-2 bg-blue-500 text-white">Subscribe</button></jet-button>
                              </div>
                              <jet-button @click="moveToNextPage(data.id,$event)" class="w-full hover:no-underline" style="position:absolute; bottom:0; left:0; right:0"> <button type="button" class="w-full text-white p-2 bg-blue-500">Try now</button></jet-button>
                            </div>
                        </div>
                       
                     
                    </div>
                </div>
      
            </div>
        </section>
    <!-- pricing table ends -->

      <!-- FAQ section - START -->
    
    
    
    <section id="faq">
        <div class="container">

            <h2 class="text-center features-heading mt-5">Frequently Asked Questions</h2>

            <!-- <div class="faq-header">Frequently Asked Questions</div> -->

            <div class="faq-content">
                <div class="faq-question">
                    <input id="q1" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q1" class="panel-title">What is the meaning of life?</label>
                    <div class="panel-content">42</div>
                </div>

                <div class="faq-question">
                    <input id="q2" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q2" class="panel-title">How much wood would a woodchuck chuck?</label>
                    <div class="panel-content">A woodchuck would chuck all the wood he could chuck, if a woodchuck could
                        chuck wood!</div>
                </div>

                <div class="faq-question">
                    <input id="q3" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q3" class="panel-title">What happens if Pinocchio says, "my nose will grow now"?</label>
                    <div class="panel-content">Certain questions are better left &nbsp; <a
                            href="https://en.wikipedia.org/wiki/The_Unanswered_Question" target="_blank">unanswered</a>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <!-- FAQ section - END -->




  </div>
</template>

<script>

    import { Head, Link } from '@inertiajs/inertia-vue3';
    import Navigation from "@/Layouts/Navigation.vue";
    import AppLayout from "@/Layouts/AppLayout.vue";
      import JetNavLink from '@/Jetstream/NavLink.vue'
export default {
 props: {
            canLogin: Boolean,
            canRegister: Boolean,
            plansData: String,
            product_id:String,
        },
        components: {
            AppLayout,
            Navigation,
            JetNavLink,
        },
         data() {
        return {
            //url: '/' 
        }
        
    },
    methods: {
         moveToNextPage(subid,event){
               
                let elements = (event.target.parentElement.parentElement.parentElement).getElementsByTagName("select");
                var option = $(elements).children("option:selected").val();

                if (option === "Choose Pricing" ){
                    alert("Kindly select a pricing");
                }else{
                    //console.log(subid);
                    //make an array of all the selected options

                    var data = {"product_id":this.product_id,"subscriptionPlanId":subid,"pricing_id":option};

                    
                   this.$inertia.post(route("marketplaces.organisations"),data);

                }
                
            },
             onChange(event) {
                console.log("SelectedID::"+event.target.value);
            }
    }
    
}
</script>

<style>
.img_size{


    height:auto;
    width:155px;
}
:root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }

    * {
        outline: none;
    }

    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /*Scroll - END*/

    .banner-img {
        width: 100%;
    }

    .img-product {
        width: 20%;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }

    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }

    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }

    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }

    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {

        .title-product {
            font-weight: 500 !important;
            font-size: 14px;
        }

        .detail-product {
            font-size: 12px;
        }

        .product-container {
            border: 1px solid var(--black);
            border-radius: 4px;
            height: 140px;
            transition: 0.2s;
        }

        .product-container:hover {
            border-radius: 10px;
            box-shadow: 0 0 2px 4px var(--blue);
        }

        .view-more-button {
            border: 1px solid var(--black);
            background-color: #0068CA;
            font-size: 10px;
            font-weight: bold;
            color: white;
            position: absolute;
            bottom: 5px;
            border-radius: 20px;
        }
    }

    .product-heading {
        font-weight: 600 !important;
        font-size: 16px !important;
    }

    .trial-form {
        background: var(--white);
        border: 1px solid #D5D9DC;
        padding: 6px;
        width: 100%;
    }

    .terms-privacy-text {
        font-weight: bold;
        text-decoration: underline;
    }

    .bubble-background {
        position: absolute;
        width: 25%;
    }

    .home-container {
        display: grid;
        height: 80vh;
        place-content: center;
        place-items: center;
    }

    /*Text animation - START*/

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 48%;
        }

        .cloud-divider {
            margin-top: 800px;
        }
    }

    @media only screen and (min-width: 400px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 44%;
        }

        .cloud-divider {
            margin-top: 190px;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 39%;
        }

        .cloud-divider {
            margin-top: 180px;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .content {
            display: none;
        }

        .home-main-text {
            margin-top: 45px;
        }

        .cloud-divider {
            margin-top: 0px;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .content {
            display: block;
        }

        .home-main-text {
            margin-top: 40px;
        }

        .cloud-divider {
            margin-top: 0px;
        }
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .content {
            display: block;
        }

        .home-main-text {
            margin-top: 40px;
        }

        .cloud-divider {
            margin-top: 0px;
        }
    }

    .content {
        overflow: hidden;
        font-family: "Lato", sans-serif;
        font-size: 35px;
        line-height: 40px;
        color: var(--black);
    }

    .free-trial-btn {
        width: 100%;
        border: 1px solid #FF4B69;
        background-color: #FF4B69;
        color: white;
    }

    .product-pic {
        width: 100%;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .home-container {
            margin-top: 120px;
        }
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        .home-container {
            margin-top: 70px;
        }
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .home-container {
            margin-top: 50px;
        }
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .home-container {
            margin-top: 50px;
        }
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        .home-container {
            margin-top: 0px;
        }
    }

    .nav-link-header {
        color: #9c761f !important;
        font-weight: 600 !important;
    }

    .search-button {
        border: 1px solid #011969;
        font-style: normal;
        margin-left: 4px;
        font-weight: 600;
        background-color: #001969;
        color: white;

    }

    .search-button:hover {
        text-decoration: none;
        color: #ffffff;
    }

    html,
    body {
        max-width: 100%;
        overflow-x: hidden;
    }

    .why-icons {
        font-size: 250%;
        color: #ffffff;
    }

    .adv-text {
            font-weight: bold;
            margin-top: 20px;
            font-size: 16px;
        }

        .lines {
            border-radius: 60px;
            transition: .5s;
            background-size: cover;
        }

        .category {
            color: #333333;
        }

    /* .hvr-pulse{
        transition: 0.2s;
    }
    .hvr-pulse:hover{
        box-shadow: 0 0 8px 0.2px white;        
    } */
    
    
        /*What we do, Desktop, Mobile - START*/

    @media only screen and (max-width: 600px) {

        .what_we_do_desktop_container {
            display: none;
        }

        .what_we_do_mobile_container {
            display: block;
        }

    }


    @media only screen and (min-width: 600px) {

        .what_we_do_desktop_container {
            display: none;
        }

        .what_we_do_mobile_container {
            display: block;
        }

    }


    @media only screen and (min-width: 768px) {

        .what_we_do_desktop_container {
            display: none;
        }

        .what_we_do_mobile_container {
            display: block;
        }

    }


    @media only screen and (min-width: 992px) {

        .what_we_do_desktop_container {
            display: block;
        }

        .what_we_do_mobile_container {
            display: none;
        }

    }


    @media only screen and (min-width: 1200px) {
        .what_we_do_desktop_container {
            display: block;
        }

        .what_we_do_mobile_container {
            display: none;
        }
    }

    img.vert-move {
        -webkit-animation: mover 1.5s infinite alternate;
        animation: mover 1.5s infinite alternate;
    }

    img.vert-move-two {
        -webkit-animation: mover 1.3s infinite alternate;
        animation: mover 1.3s infinite alternate;
    }

    @-webkit-keyframes mover {
        0% {
            transform: translateY(0);
        }

        100% {
            transform: translateY(-30px);
        }
    }

    @keyframes mover {
        0% {
            transform: translateY(0);
        }

        100% {
            transform: translateY(-30px);
        }
    }

    /*What we do, Desktop, Mobile - END*/
    

    .card-pricing .list-unstyled li {
            padding: 0.5rem 0;
            color: #6c757d;
        }

        .card {
            border-color: #6C757D;
        }

        #plansPricing {
            background-color: #EFEFEF;
        }

        /* pricing style ends */
    

    .card-pricing .list-unstyled li {
            padding: 0.5rem 0;
            color: #6c757d;
        }

        .card {
            border-color: #6C757D;
        }

        #plansPricing {
            background-color: #EFEFEF;
        }

        /* pricing style ends */


        .faq-header {
        font-size: 42px;
        border-bottom: 1px dotted #ccc;
        padding: 24px;
    }

    .faq-content {
        margin: 0 auto;
    }

    .faq-question {
        padding: 20px 0;
        border-bottom: 1px dotted #ccc;
    }

    .panel-title {
        font-size: 24px;
        width: 100%;
        position: relative;
        margin: 0;
        padding: 10px 10px 0 48px;
        display: block;
        cursor: pointer;
    }

    .panel-content {
        font-size: 20px;
        padding: 0px 14px;
        margin: 0 40px;
        height: 0;
        overflow: hidden;
        z-index: -1;
        position: relative;
        opacity: 0;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.panel-content {
        height: auto;
        opacity: 1;
        padding: 14px;
    }

    .plus {
        position: absolute;
        margin-left: 20px;
        margin-top: 4px;
        z-index: 5;
        font-size: 42px;
        line-height: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.plus {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .panel {
        display: none;
    }

    	.mobile-section-h3{
    	color: #333;
		font-weight: 600;
    }
    </style>
